import styled from 'styled-components';

export const AddressContainer = styled.div`
    width: 100%;
    padding-top: 16px;
    display: flex;
    flex-direction: column;

    .main {
        margin-top: 16px;
        flex: 1;

        ${(props) => props.theme.breakpointTo.sm} {
            margin-top: 0;
            padding-bottom: 32px;
        }
    }

    .actions {
        margin-top: 24px;
        display: flex;
        width: 100%;
        gap: 16px;

        ${(props) => props.theme.breakpointTo.sm} {
            position: sticky;
            bottom: 24px;
            flex-direction: column;
            gap: 12px;
            margin-top: auto;
        }

        .button {
            width: calc(50% - 8px);
            ${(props) => props.theme.breakpointTo.sm} {
                width: 100%;
            }
        }

        .retake-icon {
            width: 16px;
            height: 16px;
            transform: scale(1.5);
        }

        .full-width-button {
            width: 100%;
        }

        .secondary {
            background-color: ${(props) => props.theme.palette.primaryA7};
        }
    }

    .upload-container {
        ${(props) => props.theme.breakpointTo.sm} {
            margin-top: 24px;
        }
    }

    .hidden {
        display: none;
    }
`;
